module.exports = {
  alignItems: { value: 'center' },
  alignContent: { value: 'center' },
  justifyContent: { value: 'flex-start' },
};
